export default {
  group: {
    rechargeBehavior: 'Nhãn hành vi nạp tiền',
    withdrawBehavior: 'Nhãn hành vi rút tiền',
    betBehavior: 'Nhãn hành vi cá cược',
    gamePreference: 'Nhãn sở thích game',
    lifecycle: 'Nhãn vòng đời',
    userValue: 'Nhãn giá trị người dùng',
  },
  field: {
    tagName: 'Nhãn',
    hitCount: 'Số người dùng',
    hitDescription: 'Mô tả',
    operation: 'Thao tác',
    refreshDays: 'Chu kỳ cập nhật',
    lastUpdateTime: 'Cập nhật gần nhất',
    nextUpdateTime: 'Cập nhật tự động tiếp theo',
    refreshCycle: 'Chu kỳ',
    configSetting: 'Cài đặt',
  },
  action: {
    enable: 'Bật',
    disable: 'Tắt',
    setting: 'Cài đặt',
    save: 'Lưu',
    back: 'Quay lại',
    manualUpdate: 'Cập nhật thủ công',
    updating: 'Đang cập nhật...',
    confirm: 'Đồng ý',
  },
  unit: {
    days: 'Ngày',
  },
  connector: {
    and: 'và ≤',
  },
  pageTitle: 'Cài đặt nhãn tự động',
  settingTitle: ' Cài đặt',
  noAutoTags: 'Không có nhãn tự động',
  message: {
    statusUpdateSuccess: 'Cập nhật trạng thái thành công',
    statusUpdateFailed: 'Cập nhật trạng thái thất bại',
    saveSuccess: 'Lưu thành công',
    saveFailed: 'Lưu thất bại',
    configRequired: 'Tất cả các trường không được để trống, vui lòng hoàn thành cấu hình',
    manualUpdateSuccess: 'Đã kích hoạt cập nhật thủ công, đang tính toán. Vui lòng làm mới sau.',
    manualUpdateFailed: 'Cập nhật thủ công thất bại',
    groupCalculating: 'Nhóm nhãn này đang được cập nhật tự động, vui lòng thử lại sau.',
  },
  configRule: {
    integerOnly: 'Chỉ số nguyên dương',
    amountUnit: 'Đơn vị tiền tệ giống với đơn vị nạp tiền của nền tảng',
    emptyDisabled: 'Nhãn có ngưỡng trống sẽ không được xét trúng cho loại tiền tệ này',
  },
  tag: {
    FIRST_RECHARGE: 'Người dùng nạp lần đầu',
    NO_RECHARGE: 'Chưa nạp tiền',
    RECHARGE_FREQ_LOW: 'Tần suất nạp thấp',
    RECHARGE_FREQ_MID: 'Tần suất nạp trung bình',
    RECHARGE_FREQ_HIGH: 'Tần suất nạp cao',
    RECHARGE_AMT_LOW: 'Nạp số tiền thấp',
    RECHARGE_AMT_MID: 'Nạp số tiền trung bình',
    RECHARGE_AMT_HIGH: 'Nạp số tiền cao',
    NO_WITHDRAW: 'Chưa rút tiền',
    WITHDRAW_FREQ_LOW: 'Tần suất rút thấp',
    WITHDRAW_FREQ_MID: 'Tần suất rút trung bình',
    WITHDRAW_FREQ_HIGH: 'Tần suất rút cao',
    WITHDRAW_AMT_LOW: 'Rút số tiền thấp',
    WITHDRAW_AMT_MID: 'Rút số tiền trung bình',
    WITHDRAW_AMT_HIGH: 'Rút số tiền cao',
    NO_BET: 'Chưa cá cược',
    BET_FREQ_LOW: 'Tần suất cược thấp',
    BET_FREQ_MID: 'Tần suất cược trung bình',
    BET_FREQ_HIGH: 'Tần suất cược cao',
    BET_AMT_LOW: 'Cược số tiền thấp',
    BET_AMT_MID: 'Cược số tiền trung bình',
    BET_AMT_HIGH: 'Cược số tiền cao',
    PREFER_LIVE: 'Thích Casino Trực tiếp',
    PREFER_SLOT: 'Thích Slot',
    PREFER_SPORT: 'Thích Thể thao',
    PREFER_CHESS: 'Thích Cờ bài',
    ACTIVE_RETAINED: 'Người dùng hoạt động',
    ACTIVE_NO_DEPOSIT: 'Hoạt động chưa nạp',
    RETURN_NO_RECHARGE: 'Quay lại chưa nạp',
    CHURN_RISK: 'Nguy cơ rời bỏ',
    CHURNED: 'Đã rời bỏ',
    NET_LOSS_HIGH: 'Thua lỗ ròng cao',
    NET_LOSS_MID: 'Thua lỗ ròng trung bình',
    NET_LOSS_LOW: 'Thua lỗ ròng thấp',
    NET_WIN_HIGH: 'Thắng ròng cao',
    NET_WIN_MID: 'Thắng ròng trung bình',
    NET_WIN_LOW: 'Thắng ròng thấp',
  },
  hitDesc: {
    FIRST_RECHARGE: 'Nạp lần đầu = 1',
    NO_RECHARGE: 'Tổng số lần nạp = 0',
    RECHARGE_FREQ_LOW: 'Tổng số lần nạp ≤ X',
    RECHARGE_FREQ_MID: 'Tổng số lần nạp ≥ X và ≤ X',
    RECHARGE_FREQ_HIGH: 'Tổng số lần nạp ≥ X',
    RECHARGE_AMT_LOW: 'Tổng tiền nạp ≤ X',
    RECHARGE_AMT_MID: 'Tổng tiền nạp ≥ X và ≤ X',
    RECHARGE_AMT_HIGH: 'Tổng tiền nạp ≥ X',
    NO_WITHDRAW: 'Tổng số lần rút = 0',
    WITHDRAW_FREQ_LOW: 'Tổng số lần rút ≤ X',
    WITHDRAW_FREQ_MID: 'Tổng số lần rút ≥ X và ≤ X',
    WITHDRAW_FREQ_HIGH: 'Tổng số lần rút ≥ X',
    WITHDRAW_AMT_LOW: 'Tổng tiền rút ≤ X',
    WITHDRAW_AMT_MID: 'Tổng tiền rút ≥ X và ≤ X',
    WITHDRAW_AMT_HIGH: 'Tổng tiền rút ≥ X',
    NO_BET: 'Tổng số lần cược = 0',
    BET_FREQ_LOW: 'Tổng số lần cược ≤ X',
    BET_FREQ_MID: 'Tổng số lần cược ≥ X và ≤ X',
    BET_FREQ_HIGH: 'Tổng số lần cược ≥ X',
    BET_AMT_LOW: 'Tổng tiền cược ≤ X',
    BET_AMT_MID: 'Tổng tiền cược ≥ X và ≤ X',
    BET_AMT_HIGH: 'Tổng tiền cược ≥ X',
    PREFER_LIVE: 'Tỷ lệ cược Casino trực tiếp ≥ 50%',
    PREFER_SLOT: 'Tỷ lệ cược Slot ≥ 50%',
    PREFER_SPORT: 'Tỷ lệ cược Thể thao ≥ 50%',
    PREFER_CHESS: 'Tỷ lệ cược Cờ bài ≥ 50%',
    ACTIVE_RETAINED: '≤ 7 ngày có cược và nạp (không phải lần đầu)',
    ACTIVE_NO_DEPOSIT: '≤ 7 ngày có cược và không nạp',
    RETURN_NO_RECHARGE: '≤ 7 ngày có cược, không nạp, lần nạp cuối ∈ [15 ngày trước, 30 ngày trước]',
    CHURN_RISK: '7 ngày liên tục không đăng nhập/cược, có nạp trong 7-15 ngày',
    CHURNED: '15 ngày liên tục không đăng nhập/cược, có nạp >30 ngày trước',
    NET_LOSS_HIGH: 'Thua ròng ≥ X',
    NET_LOSS_MID: 'Thua ròng ≥ X và ≤ X',
    NET_LOSS_LOW: 'Thua ròng ≤ X',
    NET_WIN_HIGH: 'Thắng ròng ≥ X',
    NET_WIN_MID: 'Thắng ròng ≥ X và ≤ X',
    NET_WIN_LOW: 'Thắng ròng ≤ X',
  },
  configLabel: {
    RECHARGE_FREQ_LOW: 'Tổng số lần nạp ≤',
    RECHARGE_FREQ_MID: 'Tổng số lần nạp ≥',
    RECHARGE_FREQ_HIGH: 'Tổng số lần nạp ≥',
    RECHARGE_AMT_LOW: 'Tổng tiền nạp ≤',
    RECHARGE_AMT_MID: 'Tổng tiền nạp ≥',
    RECHARGE_AMT_HIGH: 'Tổng tiền nạp ≥',
    WITHDRAW_FREQ_LOW: 'Tổng số lần rút ≤',
    WITHDRAW_FREQ_MID: 'Tổng số lần rút ≥',
    WITHDRAW_FREQ_HIGH: 'Tổng số lần rút ≥',
    WITHDRAW_AMT_LOW: 'Tổng tiền rút ≤',
    WITHDRAW_AMT_MID: 'Tổng tiền rút ≥',
    WITHDRAW_AMT_HIGH: 'Tổng tiền rút ≥',
    BET_FREQ_LOW: 'Tổng số lần cược ≤',
    BET_FREQ_MID: 'Tổng số lần cược ≥',
    BET_FREQ_HIGH: 'Tổng số lần cược ≥',
    BET_AMT_LOW: 'Tổng tiền cược ≤',
    BET_AMT_MID: 'Tổng tiền cược ≥',
    BET_AMT_HIGH: 'Tổng tiền cược ≥',
    NET_LOSS_HIGH: 'Thua ròng ≥',
    NET_LOSS_MID: 'Thua ròng ≥',
    NET_LOSS_LOW: 'Thua ròng ≤',
    NET_WIN_HIGH: 'Thắng ròng ≥',
    NET_WIN_MID: 'Thắng ròng ≥',
    NET_WIN_LOW: 'Thắng ròng ≤',
  },
}
